import namespace from "@rdf-esm/namespace";
const builder = namespace("http://www.opengis.net/ont/geosparql#");
export const strict = builder;
export const loose = builder;